import { FC, PropsWithChildren } from 'react'
import { useSelector } from 'react-redux'
import { useLocation } from 'react-router'
import { Navigate } from 'react-router-dom'

import { Spinner } from '~/shared/components/Spinner/Spinner'
import { getPathFromPageId } from '~/shared/helpers/getPathFromPageId'
import { selectActionList, selectCohortID } from '~/shared/store/common/selects'
import { GET_STATUS } from '~/shared/store/user/actionTypes'
import { selectUserUUID } from '~/shared/store/user/selects'

import { useAvailableFunnelRoute } from '../hooks/useAvailableFunnelRoute'

type TProps = { isAvailable: boolean }

export const ProtectedLayout: FC<PropsWithChildren<TProps>> = ({
  isAvailable,
  children,
}) => {
  const { search } = useLocation()
  const availableRoute = useAvailableFunnelRoute()
  const uuid = useSelector(selectUserUUID)
  const cohort = useSelector(selectCohortID)
  const actionList = useSelector(selectActionList)

  const pathToRedirect = getPathFromPageId({
    pageId: availableRoute,
    cohort,
    uuid,
    currentSearch: search,
  })

  if (actionList.includes(GET_STATUS)) {
    return <Spinner />
  }

  return isAvailable ? children : <Navigate to={`/${pathToRedirect}`} />
}
